// OOTB Code
'use strict';

const { queryFirst, addClass, queryAll, removeClass } = require('../domUtil');
const { formatPhoneNumber } = require('../util');
const shippingPhoneNumberEl = queryFirst('.contact-us-phone .form-control');
const { contactUsTemplate } = require('../templates');
const hiddenClass = 'd-none';
const tulipDisabledClass = 'tulip-disabled';
const appointmentDisabledClass = 'appointment-disabled';
const textUnderlineClass = 'tulip-text-underline';

// LP custom changes start

/**
 * Sets active to seleced link.
 */
function setActive() {
    const activeLink = queryFirst('.active-link');
    addClass(queryFirst('.' + activeLink.getAttribute('data-active-link')), 'active');
}

/**
 * Expands all collapses
 */
function expandAllContent() {
    const expandAll = queryAll('.expand-all');
    if (expandAll) {
        expandAll.forEach((expandBtn) => {
            expandBtn.addEventListener('click', function () {
                const activeCard = queryFirst('.tab-content .tab-pane.show');
                const cards = queryAll('.card-header button', activeCard);
                const content = queryAll('.card-body .collapse', activeCard);
                removeClass(cards, 'collapsed');
                addClass(content, 'show');
                cards.forEach((card) => {
                    card.setAttribute('aria-expanded', true);
                });
            });
        });
    }
}

/**
 * Hides the visible subgroup of Contact Us topics
 */
function hideSelectedSubgroup() {
    const subGroup = queryFirst('.sub-group.show');
    removeClass(subGroup, 'show');
}

/**
 * Handles hiding/showing Contact Us subgroups when the user clicks the radio
 * button for certain topics.
*/
function radioHideShow() {
    const contactRadio = $('form.contact-us input[type=radio][name=contactTopic]');
    contactRadio.on('change', function (e) {
        const value = e.target.value;
        const radioGroup = queryFirst('form.contact-us .radio-group');
        removeClass(radioGroup, 'invalid-group'); // Clears out any error messaging
        hideSelectedSubgroup();
        const subgroup = queryFirst('.' + value + '-group');
        if (subgroup) {
            addClass(subgroup, 'show');
        }
    });
}

/**
 * Deselects the subtopic radio button
 */
function deselectSubtopic() {
    queryAll('input[name="subTopic"]').forEach(function (e) { e.checked = false; });
}

/**
 * Clears out any text in the other reason field
*/
function clearOtherReasonField() {
    queryFirst('#contact-reason-other-reason').value = '';
}

/**
 * Deselects the subtopic radio buttons when user focuses on the "Other Reason" form field
 */
function otherFieldFocus() {
    $('#contact-reason-other-reason').on('focus', function () {
        deselectSubtopic();
    });
}
/**
 * Clears out the other reason field when the user selects a subtopic
 */
function subtopicFocus() {
    $('input[name="subTopic"]').on('click', function () {
        // clearOtherReasonField();
    });
}
// LP custom changes end

/**
 * This method displays contact us sign up status message
 * @param {Object} data  response data
 * @param {Object} button sign up button object
 */
function displayMessage(data, button) {
    $.spinner().stop();
    let status;
    const $signupMessage = $('.contact-us-signup-message');
    if (data.success) {
        status = 'alert-success';
    } else {
        status = 'alert-danger';
    }

    if ($signupMessage.length === 0) {
        $('body').append('<div class="contact-us-signup-message"></div>');
    }
    $signupMessage.append(contactUsTemplate.signupMessage(status, data.msg));

    setTimeout(function () {
        $signupMessage.remove();
        button.removeAttr('disabled');
    }, 3000);
}

/**
 * Adds an invalid class to the radio form group if the inputs are invalid.
 */
function invalidRadioHandler() {
    $(this).parents('.radio-group').addClass('invalid-group');
}

module.exports = {
    init: function () {
        const enableTulip = queryFirst('.js-tulip-enabled');
        const tulipStylistAvailable = queryFirst('.tulip-stylist-available');
        const tulipStylistDisabled = queryFirst('.tulip-stylist-disabled');
        const tulipAppointmentAvailable = queryFirst('.tulip-appointment-available');
        const tulipAppointmentDisabled = queryFirst('.tulip-appointment-disabled');
        const chatContainer = queryFirst('.chat-container');
        const appointmentContainer = queryFirst('.appointment-container');
        const chatIcon = queryFirst('.chat-icon', chatContainer);
        const calendarIcon = queryFirst('.chat-icon', appointmentContainer);
        const chatIconDisabled = queryFirst('.chat-icon-disabled', chatContainer);
        const calendarIconDisabled = queryFirst('.chat-icon-disabled', appointmentContainer);
        const tulipChatText = queryFirst('.tulip-chat-text');
        const stylistAndAppointmentAvailable = tulipStylistAvailable && tulipAppointmentAvailable;
        const stylistAndAppointmentDisabled = tulipStylistDisabled && tulipAppointmentDisabled;
        const stylistBlock = queryFirst('.stylist-block');
        const isLoggedIn = queryFirst('.is-loggedin');
        const signInContainer = queryFirst('.sign-in-box');
        const signInLink = queryFirst('.sign-in-page');
        const myAccountLink = queryFirst('.myaccount-page');
        const findStoreContainer = queryFirst('.find-store');
        const findStoreLink = queryFirst('.find-store-link');
        if (enableTulip) {
            if (stylistAndAppointmentDisabled) {
                addClass([tulipStylistDisabled, tulipAppointmentDisabled], hiddenClass);
                removeClass(chatContainer, tulipDisabledClass);
                removeClass(appointmentContainer, appointmentDisabledClass);
            }
            if (stylistAndAppointmentAvailable) {
                removeClass([tulipStylistAvailable, tulipAppointmentAvailable], hiddenClass);
                removeClass(chatContainer, tulipDisabledClass);
                removeClass(appointmentContainer, appointmentDisabledClass);
            }
        } else {
            if (stylistAndAppointmentAvailable) {
                addClass([tulipStylistAvailable, tulipAppointmentAvailable, chatIcon, calendarIcon], hiddenClass);
                addClass(chatContainer, tulipDisabledClass);
                addClass(appointmentContainer, appointmentDisabledClass);
                removeClass([chatIconDisabled, calendarIconDisabled], hiddenClass);
                removeClass(tulipChatText, textUnderlineClass);
            }
            addClass(stylistBlock, hiddenClass);
            if (stylistAndAppointmentDisabled) {
                removeClass([tulipStylistDisabled, tulipAppointmentDisabled, chatIconDisabled, calendarIconDisabled], hiddenClass);
                addClass(chatContainer, tulipDisabledClass);
                addClass(appointmentContainer, appointmentDisabledClass);
                addClass([chatIcon, calendarIcon], hiddenClass);
                removeClass(tulipChatText, textUnderlineClass);
            }
        }
        if (signInLink && myAccountLink) {
            if (isLoggedIn && isLoggedIn.value === 'true') {
                addClass(signInLink, hiddenClass);
                removeClass(myAccountLink, hiddenClass);
                signInContainer.setAttribute('onclick', `location.href='${myAccountLink.href}'`);
            } else {
                addClass(myAccountLink, hiddenClass);
                removeClass(signInLink, hiddenClass);
                signInContainer.setAttribute('onclick', `location.href='${signInLink.href}'`);
            }
        }
        if (findStoreLink && findStoreContainer) {
            findStoreContainer.setAttribute('onclick', `location.href='${findStoreLink.href}'`);
        }
    },
    setActive: setActive,
    expandAllContent: expandAllContent,
    radioHideShow: radioHideShow,
    otherFieldFocus: otherFieldFocus,
    subtopicFocus: subtopicFocus,
    contactReasonError: function () {
        $('form.contact-us input[type=radio][name=contactTopic]').on('invalid', invalidRadioHandler);
    },
    subscribeContact: function () {
        $('form.contact-us').submit(function (e) {
            e.preventDefault();
            var form = $(this);
            var button = $('.subscribe-contact-us');
            var url = form.attr('action');

            $.spinner().start();
            button.attr('disabled', true);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    if (data.success) {
                        $('.contact-us').trigger('reset');
                        const contactUsLanding = queryFirst('.contact-us-landing-page');
                        const contactUsForm = queryFirst('form.contact-us', contactUsLanding);
                        const contactUsSuccess = queryFirst('.contact-us-success', contactUsLanding);
                        const hiddenClass = 'd-none';
                        addClass(contactUsForm, hiddenClass);
                        removeClass(contactUsSuccess, hiddenClass);
                        $.spinner().stop();
                        scrollTo(0, 0);
                    }
                },
                error: function (err) {
                    displayMessage(err, button);
                }
            });
        });
    },
    formatPhoneNumberOnChange: function () {
        if (shippingPhoneNumberEl) {
            formatPhoneNumber(shippingPhoneNumberEl);
        }
    },
    pillSelect: function () {
        $('.customer-service').on('click', '.pill-card-btn', (event) => {
            const { target } = event;
            const { targetId } = target.dataset;
            const showClass = 'show';
            const activeClass = 'active';
            const selectedCard = document.getElementById(targetId);
            queryFirst('.pills-card-select-btn').textContent = target.textContent;
            removeClass(queryAll('.tab-pane'), showClass);
            removeClass(queryAll('.tab-pane'), activeClass);
            addClass(selectedCard, showClass);
            addClass(selectedCard, activeClass);
        });
    }
};
